import React from 'react';
import { observer } from 'mobx-react-lite';
import chatStore from '../stores/chatStore';
import { useTheme } from '../theme/ThemeContext';
import { useAuth } from '../../../context/AuthContext';
import ModeToggle from '../composer/ModeToggle';

const ChatHeader = observer(() => {
    const { theme, toggle } = useTheme();
    const { user } = useAuth();
    const title = chatStore.activeChat?.title || chatStore.providerLabel;
    const contextCount = (chatStore.activeChat?.context_messages || []).length;

    return (
        <header
            className={`flex h-12 shrink-0 items-center gap-2 border-b px-3 sm:px-4 ${
                theme === 'dark' ? 'border-white/10 bg-[#212121]' : 'border-black/10 bg-white'
            }`}
        >
            <div className="flex min-w-0 flex-1 items-center gap-2">
                {chatStore.sidebarCollapsed && (
                    <button
                        type="button"
                        className="rounded-md p-1.5 hover:bg-black/5 dark:hover:bg-white/10"
                        onClick={() => chatStore.setSidebarCollapsed(false)}
                        aria-label="Открыть панель"
                    >
                        ☰
                    </button>
                )}
                <h1 className="truncate text-sm font-semibold">{title}</h1>
                {contextCount > 0 && (
                    <span
                        className={`shrink-0 rounded-full px-2 py-0.5 text-[10px] font-semibold ${
                            theme === 'dark'
                                ? 'bg-emerald-500/20 text-emerald-300'
                                : 'bg-emerald-100 text-emerald-800'
                        }`}
                        title="Сообщений контекста в этом чате"
                    >
                        ctx {contextCount}
                    </span>
                )}
            </div>

            <div className="max-w-[58%] shrink-0 overflow-x-auto sm:max-w-none">
                <ModeToggle />
            </div>

            <div className="flex min-w-0 flex-1 items-center justify-end gap-2 text-xs opacity-80">
                {chatStore.activeChatId && (
                    <button
                        type="button"
                        title={
                            contextCount
                                ? `Контекст чата (${contextCount})`
                                : 'Контекст чата'
                        }
                        aria-label="Контекст чата"
                        onClick={() => chatStore.openContextPanel(chatStore.activeChatId)}
                        className={`relative flex h-8 w-8 items-center justify-center rounded-md ${
                            theme === 'dark' ? 'hover:bg-white/10' : 'hover:bg-black/5'
                        } ${contextCount ? (theme === 'dark' ? 'text-emerald-300' : 'text-emerald-700') : ''}`}
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden>
                            <path
                                d="M12 15.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7z"
                                stroke="currentColor"
                                strokeWidth="2"
                            />
                            <path
                                d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 11-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 11-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 11-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 110-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 112.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 114 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 112.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 110 4h-.09a1.65 1.65 0 00-1.51 1z"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        {contextCount > 0 && (
                            <span className="absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full bg-emerald-500" />
                        )}
                    </button>
                )}
                <span className="hidden sm:inline">{user?.username || user?.email}</span>
                <button
                    type="button"
                    onClick={toggle}
                    className={`rounded-md px-2 py-1 ${
                        theme === 'dark' ? 'hover:bg-white/10' : 'hover:bg-black/5'
                    }`}
                >
                    {theme === 'dark' ? 'Светлая' : 'Тёмная'}
                </button>
            </div>
        </header>
    );
});

export default ChatHeader;
